export const JOIN_WAITLIST_URL = 'https://forms.office.com/r/Mp7Spem6DS';

export const CHAT_WAITLIST_STATUS = 'CHAT_WAITLIST_STATUS';

export enum WaitlistStatus {
  PENDING_JOIN,
  PENDING_GRANTED,
  GRANTED,
  CLOSED,
}
